import React from "react";
import "../../../../../css/FinancialPromotions/Components/FPPrimaryButton.css";


const FPPrimaryButton = ({ children, label,icon, ...props }) => {
  return (
    <button
      type="submit"
      disabled={props.loading}
      className="fp-form-submit"
      {...props}
    >
      <div className="FP_Body_Semibold">
        {icon && <span className="fp-button-icon">{icon}</span>}
        {props.loading ? "Submitting..." : label || children}
      </div>
    </button>
  );
};

export default FPPrimaryButton;
